module.exports = __webpack_public_path__ + "8162701cfa3e587372f28e4ceddfd102.pdf";